import { useQuery } from "@tanstack/react-query"

import couponApi from "./couponApi"

const useCouponListQuery = () => {
  const { data, isError, refetch } = useQuery(["couponApi.couponList"], couponApi.couponList)

  return { couponList: data?.couponList, isError, refetch }
}

export default useCouponListQuery
